<template>
  <div class="is-flex align-items-center">
    <svg
      v-if="type === 'docx'"
      :class="sizeClass"
      :style="style"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill="currentColor"
      overflow="hidden"
    >
      <path
        d="M594.944 0l335.124 341.32v563.2c0 65.997-52.5 119.48-117.294 119.48H209.546c-64.794 0-117.299-53.53-117.299-119.48V119.48C92.252 53.484 144.758 0 209.551 0h385.393z"
        fill="#5895ff"
      />
      <g fill="#fff">
        <path
          d="M930.068 341.32H718.152c-64.748 0-123.208-59.489-123.208-125.491V0l335.124 341.32z"
          fill-opacity=".4"
        />
        <path
          d="M427.377 725.32V768H259.814v-42.68h167.562zM594.944 640v42.68h-335.13V640h335.13zm0-85.32v42.639h-335.13V554.68h335.13zm0-85.361V512h-335.13v-42.68h335.13z"
        />
      </g>
    </svg>

    <svg
      v-else-if="type === 'pdf'"
      :class="sizeClass"
      :style="style"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill="currentColor"
      overflow="hidden"
    >
      <path
        d="M594.944 0l335.124 341.32v563.2c0 65.997-52.5 119.48-117.294 119.48H209.546c-64.794 0-117.299-53.53-117.299-119.48V119.48C92.252 53.484 144.758 0 209.551 0h385.393z"
        fill="#e94848"
      />
      <g fill="#fff">
        <path
          d="M482.954 375.48a40.586 40.586 0 0 0-40.028 40.776c0 27.786 15.171 62.326 31.181 94.771-12.564 39.834-26.716 82.473-44.82 118.502-37.094 14.797-70.195 25.83-90.061 42.168a41.708 41.708 0 0 0-12.39 29.926c0 22.344 18.063 40.776 40.038 40.776a39.332 39.332 0 0 0 29.271-12.472c14.618-17.828 31.887-50.13 47.293-79.642 35.42-14.198 72.607-28.672 108.447-37.325 26.163 21.453 64.051 35.651 95.186 35.651 21.97 0 40.033-18.386 40.033-40.776a40.586 40.586 0 0 0-40.033-40.724c-24.991 0-61.297 9.073-89.037 18.616a301.338 301.338 0 0 1-58.092-76.984c10.66-33.331 23.04-66.657 23.04-92.488a40.586 40.586 0 0 0-40.028-40.776zm0 24.438c8.98 0 16.01 7.168 16.01 16.292 0 12.237-6.42 34.816-13.87 59.018-9.958-23.552-18.15-46.172-18.15-58.972 0-9.165 7.025-16.292 16.01-16.292v-.046zm6.886 139.546a323.574 323.574 0 0 0 41.523 53.76c-23.741 6.605-46.92 15.078-69.821 23.921 11.08-25.364 19.917-51.758 28.298-77.727v.046zm157.235 52.127c8.98 0 16.01 7.122 16.01 16.292 0 9.124-7.03 16.292-16.015 16.292-18.058 0-43.658-8.284-64.184-19.876 23.552-6.794 49.203-12.749 64.184-12.749v.041zm-238.925 72.986c-11.264 20.48-22.436 39.562-30.259 49.152a15.078 15.078 0 0 1-11.028 4.188 15.964 15.964 0 0 1-16.01-16.292c.031-4.163 1.531-8.187 4.234-11.356 9.4-7.398 29.834-16.292 53.064-25.692z"
        />
        <path
          d="M930.068 341.32H718.152c-64.748 0-123.208-59.489-123.208-125.491V0l335.124 341.32z"
          fill-opacity=".4"
        />
      </g>
    </svg>

    <svg
      v-else-if="type === 'folder'"
      :class="sizeClass"
      :style="style"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1208 1024"
      fill="currentColor"
      overflow="hidden"
    >
      <path
        d="M132.516 120.474h879.437c33.27 0 60.237 26.967 60.237 60.232v409.6c0 33.27-26.967 60.237-60.237 60.237H132.516c-33.265 0-60.232-26.967-60.232-60.237v-409.6c0-33.265 26.967-60.237 60.232-60.237z"
        fill="#f9b552"
      />
      <path
        d="M469.837 0c73.185 0 132.516 59.331 132.516 132.516v84.326h469.837c73.185 0 132.516 59.336 132.516 132.521v542.121c0 73.185-59.331 132.516-132.516 132.516H132.516A132.516 132.516 0 0 1 0 891.484V349.363c0-4.035.179-8.069.543-12.047A134.257 134.257 0 0 1 0 325.274V132.516C0 59.331 59.331 0 132.516 0h337.321z"
        fill="#ffcf5c"
      />
    </svg>

    <svg
      v-else-if="type === 'image'"
      :class="sizeClass"
      :style="style"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill="currentColor"
      overflow="hidden"
    >
      <path
        d="M594.944 0l335.124 341.32v563.2c0 65.997-52.5 119.48-117.294 119.48H209.546c-64.794 0-117.299-53.53-117.299-119.48V119.48C92.252 53.484 144.758 0 209.551 0h385.393z"
        fill="#36d2ad"
      />
      <g fill="#fff">
        <path
          d="M930.068 341.32H718.152c-64.748 0-123.208-59.489-123.208-125.491V0l335.124 341.32z"
          fill-opacity=".4"
        />
        <path
          d="M613.56 426.68H278.426c-10.24 0-18.616 8.474-18.616 18.944v303.432c0 10.47 8.376 18.944 18.616 18.944h335.13c10.286 0 18.616-8.474 18.616-18.944V445.624a18.806 18.806 0 0 0-18.616-18.944zm-37.238 284.396H315.668v-94.771l55.859-56.873 93.087 94.812 55.859-56.924 55.849 56.924v56.878-.051zm-37.238-151.644a37.56 37.56 0 0 1-37.233-37.939c0-20.941 16.66-37.934 37.233-37.934 20.577 0 37.238 16.993 37.238 37.939 0 20.941-16.66 37.934-37.238 37.934z"
        />
      </g>
    </svg>

    <svg
      v-else-if="type === 'pptx'"
      :class="sizeClass"
      :style="style"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill="currentColor"
      overflow="hidden"
    >
      <path
        d="M594.944 0l335.124 341.32v563.2c0 65.997-52.5 119.48-117.294 119.48H209.546c-64.794 0-117.299-53.53-117.299-119.48V119.48C92.252 53.484 144.758 0 209.551 0h385.393z"
        fill="#fd7541"
      />
      <g fill="#fff">
        <path
          d="M930.068 341.32H718.152c-64.748 0-123.208-59.489-123.208-125.491V0l335.124 341.32z"
          fill-opacity=".4"
        />
        <path
          d="M415.278 451.446c-85.832 0-155.372 70.84-155.372 158.208 0 87.363 69.586 158.208 155.372 158.208 85.78 0 155.366-70.845 155.366-158.259H415.283V451.446z"
          opacity=".4"
        />
        <path d="M439.48 426.726v158.259h155.32c0-87.414-69.54-158.259-155.366-158.259h.046z" />
      </g>
    </svg>

    <svg
      v-else-if="type === 'xlsx'"
      :class="sizeClass"
      :style="style"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill="currentColor"
      overflow="hidden"
    >
      <path
        d="M594.944 0l335.124 341.32v563.2c0 65.997-52.5 119.48-117.294 119.48H209.546c-64.794 0-117.299-53.53-117.299-119.48V119.48C92.252 53.484 144.758 0 209.551 0h385.393z"
        fill="#1abf74"
      />
      <g fill="#fff">
        <path
          d="M930.068 341.32H718.152c-64.748 0-123.208-59.489-123.208-125.491V0l335.124 341.32z"
          fill-opacity=".4"
        />
        <path
          d="M594.616 426.824v.23h.092V768h-27.873v-.051h-83.968.046-83.144.051-139.919v-28.39l.051-.046v-85.827h-.051V625.29h.051v-85.827h-.097v-28.396l.092-.046v-55.854h-.092v-28.39h334.71l.046.046zM371.988 653.686h-84.106v85.827h84.106v-85.827zm83.082 0h-55.245v85.827h55.199v-85.827h.051zm111.759 0h-83.922v85.827h83.876v-85.827h.046zM371.988 539.459h-84.106v85.832h84.106v-85.827zm83.082 0h-55.245v85.832h55.199v-85.827h.051zm111.759 0h-83.922v85.832h83.876v-85.827h.046zm0-84.244H287.882v55.808h278.902v-55.854l.046.051z"
        />
      </g>
    </svg>

    <svg
      v-else-if="type === 'zip'"
      :class="sizeClass"
      :style="style"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill="currentColor"
      overflow="hidden"
    >
      <path
        d="M594.944 0l335.124 341.32v563.2c0 65.997-52.5 119.48-117.294 119.48H209.546c-64.794 0-117.299-53.53-117.299-119.48V119.48C92.252 53.484 144.758 0 209.551 0h385.393z"
        fill="#d0d8e1"
      />
      <g fill="#fff">
        <path
          d="M930.068 341.32H718.152c-64.748 0-123.208-59.489-123.208-125.491V0l335.124 341.32z"
          fill-opacity=".4"
        />
        <path
          d="M516.838 438.042h-31.283c-2.227 0-3.348 1.162-4.465 2.278s-1.116 3.4-1.116 5.683c2.232 4.557 3.354 10.24 3.354 14.797v147.917l3.348 22.764c0 2.284 2.232 3.4 3.354 4.516 1.116 0 2.232 1.162 2.232 1.162l5.581 3.4a45.148 45.148 0 0 1 29.051 42.122v51.2c0 2.284 1.116 4.516 3.348 4.516 1.116 0 1.116 1.162 2.237 1.162s2.232 0 3.348-1.162a32.63 32.63 0 0 0 13.404-27.274V472.156a31.652 31.652 0 0 0-32.394-34.115zM376.09 460.8L361.564 512a12.288 12.288 0 0 0 2.232 13.64c4.47 4.557 21.228 4.557 25.692 0a15.2 15.2 0 0 0 3.354-13.64l-14.525-51.2h-2.232zm-10.061-6.84c1.121-3.4 3.354-4.516 5.586-4.516h11.172c2.237 0 4.47 1.116 5.586 4.516l6.707 26.204 8.929-19.364-13.409-31.836v-2.33h-30.152v2.33L349.276 460.8l8.934 21.596 7.818-28.39v-.051zm-11.633-27.28l-11.172 31.841v4.557l11.172 28.442c.691 1.413 1.91 2.504 3.395 3.021l2.191.379-4.47 13.681a23.644 23.644 0 0 0 5.581 24.996c4.475 4.562 12.288 6.845 21.228 6.845s16.758-2.284 21.228-6.845a24.294 24.294 0 0 0 6.656-21.453l-5.586-18.345c.788 0 1.536-.512 1.956-1.162l.323-1.116 14.525-28.442a3.492 3.492 0 0 0 .742-3.118l-.742-1.393-14.525-31.887h35.748a33.05 33.05 0 0 1 33.234 29.373l.282 4.746v164.956c0 8.796 4.931 15.923 11.96 19.922l11.494 5.12a32.86 32.86 0 0 1 22.016 26.998l.328 4.884v51.2c0 17.69-12.196 31.652-28.856 33.843l-4.659.276H298.547a33.05 33.05 0 0 1-33.234-29.414l-.282-4.705V460.8c0-17.69 12.196-31.652 28.861-33.843l4.654-.276H354.4zm16.753 284.396h-11.162c-3.354 0-5.586 2.324-5.586 5.724 0 2.744 1.393 4.746 3.722 5.448l1.864.23h11.167c3.354 0 5.586-2.278 5.586-5.678 0-2.744-1.393-4.746-3.722-5.448l-1.864-.23v-.051zm33.516-11.356h-11.172c-3.348 0-5.581 2.324-5.581 5.724 0 2.698 1.393 4.7 3.717 5.396l1.864.282h11.172c3.348 0 5.581-2.33 5.581-5.683 0-2.79-1.393-4.741-3.717-5.443l-1.864-.276zm-33.516-11.361h-11.162c-3.354 0-5.586 2.284-5.586 5.683 0 2.744 1.393 4.746 3.722 5.443l1.864.236h11.167c3.354 0 5.586-2.284 5.586-5.683 0-2.744-1.393-4.746-3.722-5.396l-1.864-.282zm33.516-11.402h-11.172c-3.348 0-5.581 2.33-5.581 5.724 0 2.703 1.393 4.705 3.717 5.402l1.864.276h11.172c3.348 0 5.581-2.278 5.581-5.678 0-2.744-1.393-4.746-3.717-5.443l-1.864-.282zM371.149 665.6h-11.162c-3.354 0-5.586 2.278-5.586 5.683 0 2.739 1.393 4.741 3.722 5.443l1.864.23h11.167c3.354 0 5.586-2.232 5.586-5.678 0-2.698-1.393-4.7-3.722-5.396l-1.869-.282zm33.516-11.356h-11.172c-3.348 0-5.581 2.232-5.581 5.678 0 2.698 1.393 4.7 3.717 5.396l1.864.282h11.172c3.348 0 5.581-2.278 5.581-5.683 0-2.739-1.393-4.741-3.717-5.443l-1.864-.23zm-33.516-11.402h-11.162c-3.354 0-5.586 2.278-5.586 5.678 0 2.744 1.393 4.746 3.722 5.443l1.864.282h11.167c3.354 0 5.586-2.33 5.586-5.724 0-2.703-1.393-4.705-3.722-5.402l-1.864-.276zm33.516-11.361h-11.172c-3.348 0-5.581 2.284-5.581 5.683 0 2.744 1.393 4.746 3.717 5.396l1.864.282h11.172c3.348 0 5.581-2.284 5.581-5.683 0-2.744-1.393-4.746-3.717-5.443l-1.864-.236zm-33.516-11.402h-11.162c-3.354 0-5.586 2.33-5.586 5.683 0 2.79 1.393 4.741 3.722 5.443l1.864.276h11.167c3.354 0 5.586-2.324 5.586-5.724 0-2.698-1.393-4.7-3.722-5.396l-1.864-.282zm33.516-11.356h-11.172c-3.348 0-5.581 2.278-5.581 5.678 0 2.744 1.393 4.746 3.717 5.448l1.864.23h11.172c3.348 0 5.581-2.278 5.581-5.678 0-2.744-1.393-4.746-3.717-5.448l-1.864-.23zm-33.516-11.402h-11.162c-3.354 0-5.586 2.324-5.586 5.724 0 2.698 1.393 4.7 3.722 5.396l1.864.282h11.167c3.354 0 5.586-2.33 5.586-5.683 0-2.79-1.393-4.741-3.722-5.443l-1.864-.276zm33.516-11.361h-11.172c-3.348 0-5.581 2.284-5.581 5.683 0 2.744 1.393 4.746 3.717 5.443l1.864.236h11.172c3.348 0 5.581-2.284 5.581-5.683 0-2.744-1.393-4.746-3.717-5.396l-1.864-.282zm-33.516-11.402h-11.162c-3.354 0-5.586 2.33-5.586 5.724 0 2.703 1.393 4.705 3.722 5.402l1.864.276h11.167c3.354 0 5.586-2.278 5.586-5.678 0-2.744-1.393-4.746-3.722-5.443l-1.864-.282zm33.516-11.356h-11.172c-3.348 0-5.581 2.278-5.581 5.683 0 2.739 1.393 4.741 3.717 5.443l1.864.23h11.172c3.348 0 5.581-2.232 5.581-5.678 0-2.698-1.393-4.7-3.717-5.396l-1.864-.282zm-33.516-11.356h-11.162c-3.354 0-5.586 2.232-5.586 5.678 0 2.698 1.393 4.7 3.722 5.396l1.864.282h11.167c3.354 0 5.586-2.278 5.586-5.683 0-2.739-1.393-4.741-3.722-5.443l-1.864-.23z"
        />
      </g>
    </svg>

    <svg
      v-else
      :class="sizeClass"
      :style="style"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill="currentColor"
      overflow="hidden"
    >
      <path
        d="M594.944 0l335.124 341.32v563.2c0 65.997-52.5 119.48-117.294 119.48H209.546c-64.794 0-117.299-53.53-117.299-119.48V119.48C92.252 53.484 144.758 0 209.551 0h385.393z"
        class="text-primary-500"
      />
      <g fill="#fff">
        <path
          d="M930.068 341.32H718.152c-64.748 0-123.208-59.489-123.208-125.491V0l335.124 341.32z"
          fill-opacity=".4"
        />
        <path
          d="M427.377 725.32V768H259.814v-42.68h167.562zM594.944 640v42.68h-335.13V640h335.13zm0-85.32v42.639h-335.13V554.68h335.13zm0-85.361V512h-335.13v-42.68h335.13z"
        />
      </g>
    </svg>

    <!--    <svg v-else-->
    <!--         :class="sizeClass"-->
    <!--         xmlns="http://www.w3.org/2000/svg"-->
    <!--         viewBox="0 0 1024 1024"-->
    <!--         fill="currentColor"-->
    <!--         overflow="hidden">-->
    <!--      <path d="M137.902 0a48.573 48.573 0 0 0-35.589 15.293 53.965 53.965 0 0 0-15.273 35.64v917.411a48.707 48.707 0 0 0 15.273 35.64 49.971 49.971 0 0 0 35.589 15.293h746.337a48.64 48.64 0 0 0 35.589-15.293 50.371 50.371 0 0 0 15.273-35.64V288.717L646.728 0H137.902z"-->
    <!--            class="text-primary-500"/>-->
    <!--      <path d="M935.102 288.717H697.656c-27.822-.666-50.227-23.076-50.929-50.934V0l288.374 288.717z" class="text-primary-400"/>-->
    <!--      <path d="M248.126 365.184h220.518a25.518 25.518 0 0 0 24.192-25.498 25.518 25.518 0 0 0-24.197-25.503H248.126a25.518 25.518 0 0 0-24.197 25.498 25.518 25.518 0 0 0 24.197 25.498zm0 169.825H773.95a25.446 25.446 0 1 0 0-50.934H248.126a25.446 25.446 0 1 0 0 50.934zM773.95 653.896H248.126a25.518 25.518 0 0 0-24.197 25.498 25.518 25.518 0 0 0 24.197 25.503H773.95a25.518 25.518 0 0 0 24.197-25.498 25.518 25.518 0 0 0-24.197-25.498z"-->
    <!--            class="text-primary-100"/>-->
    <!--    </svg>-->
  </div>
</template>

<script>
export default {
  name: "FileIcon",

  props: {
    extension: { required: true, type: String },
    // Size one of: sm, md, lg
    size: { required: false, default: "md" },
    // For non-tailwind implementations
    dimensions: { required: false, default: () => ({ width: null, height: null }) },
  },

  data() {
    return {
      types: {
        docx: "docx",
        doc: "docx",
        jpeg: "image",
        jpg: "image",
        png: "image",
        gif: "image",
        svg: "image",
        zip: "zip",
        folder: "folder",
        pdf: "pdf",
        ppt: "pptx",
        pptx: "pptx",
        xls: "xlsx",
        xlsx: "xlsx",
        csv: "xlsx",
        tsv: "xlsx",
      },
    }
  },

  computed: {
    type() {
      const extension = this.extension?.toLowerCase()

      return typeof this.types[extension] !== "undefined" ? this.types[extension] : "txt"
    },

    style() {
      let style = ""
      if (this.dimensions.width) {
        style += "width: " + this.dimensions.width + ";"
      }

      if (this.dimensions.height) {
        style += "height: " + this.dimensions.height + ";"
      }

      return style
    },

    sizeClass() {
      switch (this.size) {
        case "sm":
          return "w-4 h-4"
        case "md":
          return "w-5 h-5"
        case "lg":
          return "w-6 h-6"
        case "xl":
          return "w-7 h-7"
        default:
          return "w-4 h-4"
      }
    },
  },
}
</script>

<style scoped></style>
